module.exports = __webpack_public_path__ + "static/media/keep-safe-tip06.fd32a968.png";